import { Box, Stack } from "@mui/material";
import { type SxProps } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { ProgressCarousel } from "@src/appV2/redesign/components/ProgressCarousel";
import { TopLeftBackButton } from "@src/appV2/redesign/components/TopLeftBackButton";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface RecapStepProps {
  onNext: () => void;
  onBack: () => void;
  stepNumber: number;
  totalPages: number;
  primaryText: string;
  secondaryText?: string;
  buttonText: string;
  sx?: SxProps;
  progressCarousel?: {
    currentIndex: number;
    totalSteps: number;
    onIndexChange: (index: number) => void;
  };
}

export function RecapStep(props: RecapStepProps) {
  const {
    onNext,
    onBack,
    stepNumber,
    totalPages,
    primaryText,
    secondaryText,
    buttonText,
    sx,
    progressCarousel,
  } = props;

  return (
    <Stack
      spacing={6}
      alignItems="center"
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "space-between",
        // oxlint-disable-next-line typescript/no-misused-spread -- MUI SxProps union includes functions, but spreading in sx is standard MUI pattern
        ...sx,
      }}
    >
      <Box sx={{ width: "100%" }}>
        <TopLeftBackButton iconType="chevron-left" onClick={onBack} />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 6,
          width: "100%",
          maxWidth: 343,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: 1,
            alignSelf: "flex-start",
            width: "100%",
          }}
        >
          <Text
            variant="h1"
            sx={{
              fontSize: "92px",
              lineHeight: "32.5px",
              fontWeight: 500,
            }}
          >
            {stepNumber}
          </Text>
          <Text
            variant="h4"
            sx={{
              fontSize: "32px",
              lineHeight: "32.5px",
              fontWeight: 500,
            }}
          >
            /{totalPages}
          </Text>
        </Box>

        <Stack spacing={6} sx={{ width: "100%" }}>
          <Text
            variant="h4"
            sx={{
              fontSize: "24px",
              lineHeight: "29px",
              fontWeight: 500,
              textAlign: "left",
            }}
          >
            {primaryText}
          </Text>
          <Text
            variant="h4"
            sx={{
              fontSize: "24px",
              lineHeight: "29px",
              fontWeight: 500,
              textAlign: "left",
            }}
          >
            {secondaryText}
          </Text>
        </Stack>
      </Box>

      <Stack spacing={3} sx={{ width: "100%" }}>
        {progressCarousel && (
          <ProgressCarousel
            currentIndex={progressCarousel.currentIndex}
            totalCount={progressCarousel.totalSteps}
            onIndexChange={progressCarousel.onIndexChange}
          />
        )}
        <Button
          fullWidth
          size="large"
          variant="contained"
          sx={{ borderRadius: 999, height: 56 }}
          onClick={onNext}
        >
          {buttonText}
        </Button>
      </Stack>
    </Stack>
  );
}
